const Footer = () => (
  <footer className="app-footer" style={{
    padding: '14px 28px',
    borderTop: '1px solid var(--border)',
    background: 'var(--surface-1)',
    fontSize: '12px',
    color: 'var(--text-3)',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  }}>
    <span>© {new Date().getFullYear()} DHR Consultoria — Todos os direitos reservados</span>
    <a
      href="https://dhrconsultoria.com.br/"
      target="_blank"
      rel="noreferrer"
      style={{ color: 'var(--accent)', textDecoration: 'none', fontWeight: 600 }}
    >
      dhrconsultoria.com.br
    </a>
  </footer>
);

export default Footer;
